export default {
  displayBulkOrders: false,
  vendorLookup: [],
};
